import { authPost } from "@api";
import { AUTH_URL } from "@constants";
import { PostSsoDeploymentSettings } from "@types";

interface PostSsoDeploymentResponse {}

export const postSsoDeployment = (
  ssoSettings: PostSsoDeploymentSettings
): Promise<PostSsoDeploymentResponse> => {
  const url = `${AUTH_URL}/sso/sso-deployments`;
  return authPost<PostSsoDeploymentSettings, PostSsoDeploymentResponse>(
    url,
    ssoSettings
  );
};
